"use client";

import type { CSSProperties, ReactNode } from "react";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { FormMessagePrefixContext } from "@/components/ui/forms/form-message-context";
import { useListingIsland } from "./ManualListingsIsland";

/** The section's one interest form, rendered on the server and opened for the listing that asked. Headless UI unmounts
 *  a closed dialog, so the form mounts afresh with each opening and its hidden message takes that listing's prefix. */
export default function ListingInterest({
  label,
  titles,
  messages,
  className = "",
  style,
  children,
}: {
  label: string;
  titles: Record<string, string>;
  /** absent with Køberkartotek, whose action does not read the message */
  messages?: Record<string, string>;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
}) {
  const island = useListingIsland();
  const key = island.interest;
  return (
    <Dialog
      open={!!key && key in titles}
      onClose={island.closeInterest}
      className={`pf pf-family-manual-listings pf-ml-dialog pf-event-dialog ${className}`.trim()}
      style={style}
      data-purpose-family="manual-listings"
    >
      <div className="pf-modal-backdrop">
        <DialogPanel className="pf-modal">
          <div className="pf-modal-heading">
            <DialogTitle>
              {key ? `${label} – ${titles[key]}` : label}
            </DialogTitle>
            <button
              type="button"
              aria-label="Luk"
              onClick={island.closeInterest}
            >
              ×
            </button>
          </div>
          <FormMessagePrefixContext.Provider
            value={key && messages ? messages[key] : undefined}
          >
            {children}
          </FormMessagePrefixContext.Provider>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
